"use strict";

var _taggedTemplateLiteral = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n  display: block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseIcon = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var css_1 = require("@emotion/css");

var closeIconCss = (0, css_1.css)(_templateObject());

var CloseIcon = function CloseIcon() {
  return react_1.default.createElement("i", {
    className: closeIconCss
  }, react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, react_1.default.createElement("path", {
    d: "m23.542371 10.62753-1.491936-1.4919365-5.914843 5.9148425-5.914843-5.9148425-1.4919365 1.4919365 5.9148425 5.914843-5.9148425 5.914843 1.4919365 1.491936 5.914843-5.914842 5.914843 5.914842 1.491936-1.491936-5.914842-5.914843z",
    fill: "#656565",
    fillRule: "evenodd",
    strokeWidth: "1.058111"
  })));
};

exports.CloseIcon = CloseIcon;